import {
  DataLayerEventType,
  DataLayerFactory,
  TmsContextType,
} from '@awaze/mfe-common.contexts.tms'

import {
  DisplayContextProps,
  DisplayMode,
} from 'src/lib/display/displayContext'

import { dataLayerErrorHandler } from '../dataLayerErrorHandler'

type setDisplayModeWrapperReturn = (displayMode: DisplayMode) => void

export const setDisplayModeWrapper = (
  tms: TmsContextType,
  setDisplayMode: DisplayContextProps['setDisplayMode'],
): setDisplayModeWrapperReturn => {
  return (displayMode: DisplayMode) => {
    const event =
      displayMode === 'MAP'
        ? DataLayerEventType.SwitchToMap
        : DataLayerEventType.SwitchToList
    new DataLayerFactory()
      .getEvent(event)
      .update(tms, {}, dataLayerErrorHandler)

    setDisplayMode(displayMode)
  }
}
